'use client';

import { useSchedulerStoreContext } from "../use-scheduler-store-context/index.mjs";
export function useEventCalendarStoreContext() {
  const context = useSchedulerStoreContext();
  if (context.instanceName !== 'EventCalendarStore' && context.instanceName !== 'EventCalendarPremiumStore') {
    throw /* FIXME (minify-errors-in-prod): Unminified error message in production build! */new Error('MUI: useEventCalendarStoreContext must be used within an <EventCalendar /> component');
  }
  return context;
}